export default "__VITE_ASSET__BLKvUImz__"